import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M24 4c11.047 0 20 8.953 20 20s-8.953 20-20 20C12.954 44 4 35.047 4 24 4 12.954 12.953 4 24 4Zm0 2C14.057 6 6 14.058 6 24c0 9.943 8.058 18 18 18 9.943 0 18-8.058 18-18 0-9.943-8.058-18-18-18Zm9.725 14.33a1 1 0 0 0-1.414-.002l-7.236 7.217a1.5 1.5 0 0 1-2.12-.001l-7.23-7.234a1 1 0 1 0-1.415 1.414l7.23 7.233a3.5 3.5 0 0 0 4.947.004l7.236-7.216a1 1 0 0 0 .002-1.415Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "mask",
    {
      id: "Circled-Down-Outlined_svg__a",
      width: 40,
      height: 40,
      x: 4,
      y: 4,
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse"
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M24 4c11.047 0 20 8.953 20 20s-8.953 20-20 20C12.954 44 4 35.047 4 24 4 12.954 12.953 4 24 4Zm0 2C14.057 6 6 14.058 6 24c0 9.943 8.058 18 18 18 9.943 0 18-8.058 18-18 0-9.943-8.058-18-18-18Zm9.725 14.33a1 1 0 0 0-1.414-.002l-7.236 7.217a1.5 1.5 0 0 1-2.12-.001l-7.23-7.234a1 1 0 1 0-1.415 1.414l7.23 7.233a3.5 3.5 0 0 0 4.947.004l7.236-7.216a1 1 0 0 0 .002-1.415Z",
        clipRule: "evenodd"
      }
    )
  ),
  /* @__PURE__ */ React.createElement("g", { mask: "url(#Circled-Down-Outlined_svg__a)" }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M0 0h48v48H0z" }))
);
var SvgCircledDownOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var CircledDownOutlined_default = SvgCircledDownOutlined;

export { CircledDownOutlined_default as default };
